import { action, Action, computed, Computed, thunk, Thunk } from 'easy-peasy';

import {
  subscribeToBalances,
  SubscribeToBalancesParams,
} from 'services/balances';
import { IBalance } from 'types/balances';

export interface BalancesStateModel {
  balances: IBalance[];
  setState: Action<BalancesStateModel, [string, any]>;
  balanceByCurrencyCode: Computed<
    BalancesStateModel,
    (currencyCode: string) => IBalance | undefined
  >;
  subscribeToBalances: Thunk<
    BalancesStateModel,
    Omit<SubscribeToBalancesParams, 'callback'>
  >;
}

export const BalancesState: BalancesStateModel = {
  balances: [],
  setState: action((state, payload) => {
    const [prop, to] = payload;
    state[prop] = to;
  }),
  subscribeToBalances: thunk(({ setState }, { entityId }) => {
    const unsubscribeFunc = subscribeToBalances({
      entityId,
      callback: (balances) => {
        if (balances) {
          const sortedBalances = balances.sort((el) => {
            if (
              el.currency === 'GBP' ||
              el.currency === 'USD' ||
              el.currency === 'EUR'
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          setState(['balances', sortedBalances]);
        }
      },
    });

    return unsubscribeFunc;
  }),
  balanceByCurrencyCode: computed(
    [(state) => state.balances],
    (balances) => (currencyCode) =>
      balances.find((balance) => balance.currency === currencyCode)
  ),
};
